import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { config } from "./config";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    // saveMissing: true,
    // saveMissingTo: "Current",
    /* have a common namespace used around the full app */
    ns: ["translations"],
    defaultNS: "translations",
    backend: {
      loadPath: config.translationUrl
    },
  });

export default i18n;
